import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController} from '@ionic/angular';

@Component({
  selector: 'help-invite-org',
  templateUrl: './help-invite-org.component.html',
  styleUrls: ['./help-invite-org.component.scss'],
})
export class HelpInviteOrgComponent implements OnInit {
  @Input() info: string =
    '¿Cómo hacer que los ejecutores reporten a través de esta plataforma?';

  @Input() message: string = 'todo lo que necesitas saber';
  public alertButtons = ['OK'];

  constructor(private alertController: AlertController) {}

  ngOnInit() {}

  async serveInfo() {
    const msg = await this.alertController.create({
      header: 'Información',
      message: this.message,
      buttons: ['Volver'],
    });

    return await msg.present();
  }
}
